// Autoplay Button

autoplayButton = { };

autoplayButton.create = function() {
	var button = new PIXI.Container();
	
	InputHelpers.addGenerics(button);
	InputHelpers.addAutoplayFlag(button);
	InputHelpers.addCanSpinFlag(button);
    InputHelpers.addAutoplayPlatformEnabledFlag(button);
	InputHelpers.addRecoveryFlag(button);

	button._flags.disabledByPlatform = false;
	
	button.canEnable = function() {
		return (
			!this._flags.inRecovery &&
            button._flags.autoplayPlatformEnabled &&
			!this._flags.autoplayStarted &&
			this._flags.canSpin &&
			!this._flags.modal.active &&
			!this._flags.disabledByPlatform
		);
	};
	
	button.canShow = function() {
		return (!this._flags.autoplayStarted) && button._flags.autoplayPlatformVisible;
	};
	
	button.onPressedCallback = function() {
		gdk.showAutoplay();
		
		if (button.soundName !== "") {
			button.playSound();
		}
	};
	
	button.setButtonState = function(data){
		if (data.buttonName === "Autoplay"){
			this._flags.disabledByPlatform = !data.enabled;
		}
	};
	
	messageBus.subscribe("platform:setButtonState", button.setButtonState.bind(button));
	
	return button;
};

autoplayButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
autoplayButton.getFilesRequired = function() { return []; };

resourceManager.registerObjectType("autoplayButton", autoplayButton.create, autoplayButton.initialise, autoplayButton.getFilesRequired);
